export default __webpack_public_path__ + "static/media/logo-tall-light.d0965f2b.png";